import { useState } from "react";

import { Descriptions, Flex, Divider, Space, Typography } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";
import CustomTreeSelect from "@/components/inputs/CustomTreeSelect";

import { FILES_TYPES } from "@/constants/files";

export const FiltersModalContent = ({
  isAdmins,
  unit_uuid,
  tempValueFilters,
  units,
  unitsTree,
  authors,
  user,
  handleTempFilterChange,
}) => {
  const [authorSelectOpen, setAuthorSelectOpen] = useState(false);

  return (
    <Descriptions
      column={1}
      colon={false}
      styles={{
        label: {
          display: "inline-block",
          minWidth: "150px",
          color: "#777777",
        },
        content: {
          display: "block",
          marginLeft: "8px",
        },
      }}
    >
      {!unit_uuid && isAdmins ? (
        <Descriptions.Item label="Рабочая группа">
          <CustomSelect
            placeholder="Начните вводить"
            options={units}
            fieldNames={{
              label: "name",
              value: "uuid",
              key: "uuid",
            }}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="name"
            allowClear
            popupMatchSelectWidth={false}
            value={tempValueFilters?.unit_uuid}
            onChange={(unit) => handleTempFilterChange("unit_uuid", unit)}
          />
        </Descriptions.Item>
      ) : (
        <>
          <Descriptions.Item label="Рабочая группа">
            <CustomTreeSelect
              placeholder="Начните вводить"
              data={unitsTree}
              value={tempValueFilters?.units_uuids}
              onChange={(units_uuids) => {
                handleTempFilterChange("units_uuids", units_uuids);
              }}
              style={{ width: "100%" }}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Тип">
            <CustomSelect
              options={FILES_TYPES}
              style={{ width: "100%" }}
              popupMatchSelectWidth={false}
              value={tempValueFilters?.file_type}
              onChange={(val) => handleTempFilterChange("file_type", val)}
              optionRender={(option) => (
                <Flex gap={5} align="center">
                  {option?.data?.icon}
                  <span>{option.label}</span>
                </Flex>
              )}
              labelRender={(option) => {
                const item = FILES_TYPES.find(
                  (item) => item.value === option.value,
                );

                return (
                  <Flex gap={5} align="center">
                    {item?.icon}
                    <span>{item.label}</span>
                  </Flex>
                );
              }}
            />
          </Descriptions.Item>
        </>
      )}

      <Descriptions.Item label="Автор">
        <CustomSelect
          open={authorSelectOpen}
          onOpenChange={setAuthorSelectOpen}
          placeholder="Начните вводить"
          value={tempValueFilters?.author_uuid}
          options={authors}
          showSearch
          allowClear
          fieldNames={{ value: "uuid" }}
          optionFilterProp="label"
          style={{ width: "100%" }}
          placement="topRight"
          popupMatchSelectWidth={false}
          onChange={(val) => handleTempFilterChange("author_uuid", val)}
          popupRender={(menu) => (
            <>
              {menu}
              {authors.map((u) => u.uuid).includes(user.employee_uuid) && (
                <>
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space
                    style={{
                      padding: "0 8px 4px",
                    }}
                  >
                    <Typography.Link
                      onClick={() => {
                        handleTempFilterChange(
                          "author_uuid",
                          user.employee_uuid,
                        );
                        setAuthorSelectOpen(false);
                      }}
                    >
                      Я автор
                    </Typography.Link>
                  </Space>
                </>
              )}
            </>
          )}
        />
      </Descriptions.Item>
    </Descriptions>
  );
};
